import {
  Box,
  InputLabel,
  Modal,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useStyles } from "./styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import BasicButton from "components/button";
import AutoCompleteDropdown from "components/autoCompleteDropdown";
import MultiselectAutocomplete from "components/autoCompleteDropdown/multiSelectAutocomplete";
import constants from "constants/constants.json";

const SupplierModal = ({
  title,
  roles = [],
  products = [],
  primaryBtnText,
  open,
  secondaryButtonText,
  secondaryBtnAction,
  handleClose,
  supplier = {},
  role = {},
  assignedProducts = [],
}) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  const [supplierName, setSupplierName] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setSelectedProducts(assignedProducts);
      setSupplierName(supplier.supplier || "");
      setSelectedRole(role?.Name || "");
    }
  }, [assignedProducts, role, supplier, open]);

  const onSave = () => {
    let newErrors = {};
    if (!supplierName) {
      newErrors.Name = "Name is required";
    }
    if (!selectedRole) {
      newErrors.Role = "Role is required";
    }
    setErrors(newErrors);
    if (!newErrors.Name && !newErrors.Role) {
      setSupplierName("");
      setSelectedRole("");
      setErrors({});
      secondaryBtnAction(supplierName, selectedRole, selectedProducts);
    }
  };

  const handleCloseModal = () => {
    setErrors({});
    handleClose();
  };

  return (
    <Modal
      className={classes.popup}
      data-testid="popup"
      open={open}
      disableAutoFocus
      onClose={handleCloseModal}
    >
      <Box className={classes.modalWrapper}>
        <Typography
          data-testid="popupTitle"
          className={clsx(classes.text, classes.fontBold)}
          variant="h5"
          align="center"
        >
          {title}
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          <InputLabel
            className={classes.inputLabel}
            shrink={false}
            htmlFor={"supplier-name-field"}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                fontWeight: 600,
              }}
            >
              Supplier Name*
            </Typography>
          </InputLabel>
          <TextField
            slotProps={{
              inputLabel: { shrink: false },
              htmlInput: {
                maxLength: 250,
              },
            }}
            required
            error={!!errors?.Name}
            helperText={errors["Name"] || ""}
            className={classes.textInput}
            id="supplier-name-field"
            placeholder="Name"
            fullWidth
            maxLength={250}
            variant="outlined"
            value={supplierName}
            onChange={(evt) => {
              setErrors((prev) => ({ ...prev, Name: "" }));
              setSupplierName(evt.target.value);
            }}
          />
          <InputLabel
            className={classes.inputLabel}
            shrink={false}
            htmlFor={"role-field"}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                fontWeight: 600,
              }}
            >
              Role*
            </Typography>
          </InputLabel>

          <AutoCompleteDropdown
            required
            noOptionsText={constants.noRoles}
            Id="select-outlined"
            value={selectedRole}
            lists={roles}
            setDropdownValue={(evt, value) => {
              setErrors((prev) => ({ ...prev, Role: "" }));
              setSelectedRole(value);
            }}
          />
          {errors.Role && (
            <Typography
              color="error"
              align="left"
              variant="caption"
              sx={{ mt: -1 }}
            >
              {errors.Role}
            </Typography>
          )}
          <InputLabel
            className={classes.inputLabel}
            shrink={false}
            htmlFor={"role-field"}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                fontWeight: 600,
              }}
            >
              Products*
            </Typography>
          </InputLabel>

          <MultiselectAutocomplete
            placeholder="Select Products"
            required
            noOptionsText={"No products found"}
            Id="select-outlined"
            selectedItems={selectedProducts}
            lists={products}
            setSelectedValues={setSelectedProducts}
          />
        </Box>
        <Box className={classes.btnWrapper}>
          <BasicButton
            title={primaryBtnText}
            data-testid="btn"
            onClick={handleCloseModal}
          />
          <BasicButton
            title={secondaryButtonText}
            data-testid="btn2"
            onClick={onSave}
          />
        </Box>
      </Box>
    </Modal>
  );
};

SupplierModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  primaryBtnText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryBtnAction: PropTypes.func,
  handleClose: PropTypes.func,
  roles: PropTypes.array,
  products: PropTypes.array,
  role: PropTypes.object,
  supplier: PropTypes.object,
  assignedProducts: PropTypes.array,
};
export default SupplierModal;
